import { Injectable } from "@angular/core";
import { ServiceResponse } from "@data/response";
import { GenericConfig } from "@data/hubConfig";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";

const API_URL = API.API_URL;

@Injectable({
	providedIn: "root"
})
export class HubConfigsService {
	private _serviceURL = `${API_URL}/hub/config`;

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	setGenericConfig(body: string): Observable<any> {
		return this.httpManager.httpPost<any>(`${this._serviceURL}/set`, body);
	}

	/*-------- Assessments --------*/
	getAssessmentConfigQuestionTypes(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "assessQuestionType"
		});
	}

	/*-------- Course Player --------*/
	getCoursePlayerConfig_Versions(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cpVersion"
		});
	}

	getCoursePlayerConfig_Version_Find(versionNumber: string): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(
			`${this._serviceURL}/courseplayer/version/${versionNumber}/find`
		);
	}

	/*-------- Course Versions --------*/
	getCourseConfig_Audience(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvAudience"
		});
	}

	getCourseConfig_Category(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvCategory"
		});
	}

	getCourseConfig_CEType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvCeType"
		});
	}
	getCourseConfig_ComponentTags(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvComponentTag"
		});
	}

	getCourseConfig_DeliveryPlatform(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvDeliveryPlatform"
		});
	}

	getCourseConfig_LengthType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvLengthType"
		});
	}

	getCourseConfig_MediaType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvMediaType"
		});
	}

	getCourseConfig_ContributorRole(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "cvContributorRole"
		});
	}

	/*-------- JAICE Detail --------*/

	getJaiceConfig_ActivityType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "jaiceActivity"
		});
	}

	getJaiceConfig_AudienceType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "jaiceAudience"
		});
	}

	getJaiceConfig_ProvidershipType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "jaiceProvidership"
		});
	}

	/*-------- Organizations --------*/

	getOrganizationConfigExportFormat(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "orgExportFormat"
		});
	}

	getOrganizationConfigParticipationType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "orgParticipationType"
		});
	}

	getOrganizationConfigStaffedBedRange(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "orgStaffedBedRange"
		});
	}

	/*-------- Products --------*/

	getProductConfig_ContentClassification(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "prodClassification"
		});
	}

	getProductConfig_ProductType(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "prodType"
		});
	}

	getProductConfig_ReviewCycle(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "prodReviewCycle"
		});
	}

	getProductConfig_Subject(active = true): Observable<ServiceResponse<GenericConfig[]>> {
		return this.responseHandler.httpGet<GenericConfig[]>(`${this._serviceURL}/get`, {
			active: active,
			configType: "prodSubject"
		});
	}
}
